import { createStyles, makeStyles } from '@material-ui/core/styles';
import { theme } from '../Theme';
var useStyles = makeStyles(function () {
  var _theme$colors = theme.colors,
      grayColor = _theme$colors.grayColor,
      primaryColor = _theme$colors.primaryColor;
  return createStyles({
    root: {
      margin: '0 3px',
      '& label.Mui-focused': {
        color: function color(props) {
          return !props.error && primaryColor;
        }
      },
      '& .MuiInput-underline': {
        '&:after': {
          borderBottomColor: function borderBottomColor(props) {
            return !props.error && primaryColor;
          }
        }
      },
      '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
          borderColor: function borderColor(props) {
            return !props.error && grayColor;
          }
        },
        '&.Mui-focused fieldset': {
          borderColor: function borderColor(props) {
            return !props.error && primaryColor;
          }
        },
        '&.Mui-disabled fieldset': {
          borderColor: function borderColor(props) {
            return !props.error && 'rgba(0, 0, 0, 0.18)';
          }
        }
      },
      '& .MuiFilledInput-underline': {
        '&:before': {
          borderBottomColor: function borderBottomColor(props) {
            return !props.error && grayColor;
          }
        },
        '&:after': {
          borderBottomColor: function borderBottomColor(props) {
            return !props.error && primaryColor;
          }
        }
      },
      '& .MuiSvgIcon-root': {
        opacity: 0.7
      }
    }
  });
});
export default useStyles;